import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms'
import { Observable, of } from 'rxjs'

/**
 * Validator to conditionally run a validator if predicate is met
 */
export function validateIf(
  predicate: () => boolean,
  validator: ValidatorFn,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const test = predicate()
    if (!control.value && test) {
      return validator(control)
    }
    return null
  }
}

/**
 * Validator to conditionally require a value if a predicate is evaluated to true.
 */
export function asyncValidateIf(
  predicate: () => boolean,
  validator: AsyncValidatorFn,
): AsyncValidatorFn {
  return (
    control: AbstractControl,
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    const test = predicate()
    if (test) {
      return validator(control)
    }
    return of(null)
  }
}
